import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-upload-req-step-workflow',
  templateUrl: './upload-req-step-workflow.component.html'
})
export class UploadReqStepWorkflowComponent implements OnChanges {

  @Input() job: any = {};
  @Input() isCorporate;
  @Input() intelligencePreferences: any = {};
  @Input() autoMatchingPreferences: any = {};
  @Input() recruiterScreeningPreferences: any = {};
  @Input() techAssessmentPreferences: any = {};
  @Input() techAssessmentList: any[] = [];
  @Input() valueAssessmentPreferences: any = {};
  @Input() valueAssessmentList: any[] = [];
  @Input() verificationPreferences: any = {};
  @Input() phoneScreenPreferences: any = {};
  @Input() interviewPreferences: any = {};
  @Input() imageProctoringPreferences: any = {};
  @Input() addImagesToReportPreferences: any = {};
  @Input() disableWorkflowSettings;
  @Input() candidatesPresentOnJob;
  @Input() isAnyWorkflowStepsEnabled;
  @Input() selectedJobType;
  @Input() workflowStepsOrder: any = {};
  @Input() workflowStepsOrderToRender: any = {};
  @Input() step3Error: any = {};
  @Input() step3Submitted;

  @Output() stepSelectionChangeCallback = new EventEmitter<{ stepStatus: any, stepDetails: any, verificationStepName?: string }>();
  @Output() assessmentChangeCallback = new EventEmitter<string>();
  @Output() imageProctoringCheckboxClickCallback = new EventEmitter<void>();
  @Output() requiredFieldsValidChange = new EventEmitter<boolean>();

  MESSAGECONSTANTS = MESSAGECONSTANTS;

  ngOnChanges() {
    this.requiredFieldsValidChange.emit(this._areRequiredFieldsValid());
  }

  private _areRequiredFieldsValid(): boolean {
    const job = this.job || {};
    const techAssessmentValid = !(this.techAssessmentPreferences && this.techAssessmentPreferences.enabled && job.techAssessment) || !!job.techAssessmentId;
    const valueAssessmentValid = !(this.valueAssessmentPreferences && this.valueAssessmentPreferences.enabled && job.valueAssessment) || !!job.valueAssessmentId;
    return techAssessmentValid && valueAssessmentValid;
  }

  onStepSelectionChange(stepStatus: any, stepDetails: any, verificationStepName?: string) {
    this.stepSelectionChangeCallback.emit({ stepStatus, stepDetails, verificationStepName });
    this.requiredFieldsValidChange.emit(this._areRequiredFieldsValid());
  }

  onAssessmentChange(assessmentType: string) {
    this.assessmentChangeCallback.emit(assessmentType);
    this.requiredFieldsValidChange.emit(this._areRequiredFieldsValid());
  }

  onImageProctoringCheckboxClick() {
    this.imageProctoringCheckboxClickCallback.emit();
  }

  onStepDropped(event: CdkDragDrop<any[]>) {
    if (!this.selectedJobType || !this.workflowStepsOrderToRender || !this.workflowStepsOrderToRender[this.selectedJobType]) {
      return;
    }
    moveItemInArray(this.workflowStepsOrderToRender[this.selectedJobType], event.previousIndex, event.currentIndex);
  }

  trackByStepId(index: number, step: any) {
    return step && step.id;
  }

  trackByIndex(index: number) {
    return index;
  }
}
